'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _emojione = require('emojione');

var _emojione2 = _interopRequireDefault(_emojione);

var _escapeHtml = require('escape-html');

var _escapeHtml2 = _interopRequireDefault(_escapeHtml);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _size = require('lodash/size');

var _size2 = _interopRequireDefault(_size);

var _replace = require('lodash/replace');

var _replace2 = _interopRequireDefault(_replace);

var _htmlReactParser = require('html-react-parser');

var _htmlReactParser2 = _interopRequireDefault(_htmlReactParser);

var _domToReact = require('html-react-parser/lib/dom-to-react');

var _domToReact2 = _interopRequireDefault(_domToReact);

var _colors = require('../../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

var _messageHeader = require('../message-header');

var _messageHeader2 = _interopRequireDefault(_messageHeader);

var _messageTime = require('../message-time');

var _messageTime2 = _interopRequireDefault(_messageTime);

var _urlRegex = require('../../url-regex');

var _urlRegex2 = _interopRequireDefault(_urlRegex);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  avatar: _propTypes2.default.string,
  body: _propTypes2.default.node.isRequired,
  createdAt: _propTypes2.default.string.isRequired,
  username: _propTypes2.default.node.isRequired,
  type: _propTypes2.default.oneOf(['text', 'image', 'sticker', 'giphy', 'video', 'audio']),
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  messageHeaderStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  messageBodyStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  messageTimeStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  fontSize: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  myMessage: _propTypes2.default.bool,
  emoji: _propTypes2.default.bool,
  enableLinks: _propTypes2.default.bool,
  compact: _propTypes2.default.bool,
  edited: _propTypes2.default.node,
  color: _propTypes2.default.string,
  highlights: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string,
    prefix: _propTypes2.default.string,
    value: _propTypes2.default.string
  })),
  onHighlightClick: _propTypes2.default.func.isRequired,
  badge: _propTypes2.default.node,
  iconMenu: _propTypes2.default.node,
  enableMultiline: _propTypes2.default.bool
};

var defaultProps = {
  avatar: '',
  type: 'text',
  style: {},
  messageHeaderStyle: {},
  messageBodyStyle: {},
  messageTimeStyle: {},
  fontSize: 'small',
  myMessage: false,
  emoji: false,
  enableLinks: false,
  compact: false,
  color: _colors2.default.theme,
  edited: null,
  highlights: [],
  badge: null,
  iconMenu: null,
  enableMultiline: false
};

var TextMessage = function (_Component) {
  _inherits(TextMessage, _Component);

  function TextMessage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TextMessage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextMessage.__proto__ || Object.getPrototypeOf(TextMessage)).call.apply(_ref, [this].concat(args))), _this), _this.createMarkup = function () {
      var _this$props = _this.props,
          body = _this$props.body,
          enableLinks = _this$props.enableLinks,
          emoji = _this$props.emoji,
          highlights = _this$props.highlights,
          enableMultiline = _this$props.enableMultiline;


      var text = body;

      var escapedText = (0, _escapeHtml2.default)(text);

      var parsedText = escapedText;

      // XXX: Should find a prettier solution for this
      var dotCount = escapedText.match(/([0-9])+./g);

      if (enableLinks && (0, _size2.default)(dotCount) < 10) {
        var urlSchemeRegex = /^(?:https?:\/\/)/;

        parsedText = (0, _replace2.default)(escapedText, _urlRegex2.default, function (url) {
          if (!urlSchemeRegex.test(url)) {
            // Add default http:// scheme for urls like example.com
            return '<a class="link" value="http://' + url + '" href="http://' + url + '">' + url + '</a>';
          }
          return '<a class="link" value="' + url + '" href="' + url + '">' + url + '</a>';
        });
      }

      if (!(0, _isEmpty2.default)(highlights)) {
        (0, _forEach2.default)(highlights, function (highlight) {
          parsedText = (0, _replace2.default)(parsedText, '' + highlight.prefix + highlight.value, '<span class="highlight" value="' + highlight.id + '">' + highlight.prefix + highlight.value + '</span>');
        });
      }

      var html = parsedText;

      if (emoji) {
        html = _emojione2.default.toImage(parsedText);
      }

      if (enableMultiline) {
        html = (0, _replace2.default)(html, /\n/g, '<br />');
      }

      return html;
    }, _this.parseHtml = function () {
      var _this$props2 = _this.props,
          onHighlightClick = _this$props2.onHighlightClick,
          color = _this$props2.color,
          myMessage = _this$props2.myMessage,
          highlights = _this$props2.highlights;


      var options = {
        replace: function replace(domNode) {
          if (domNode.attribs && domNode.attribs.class === 'highlight') {
            var value = (0, _find2.default)(highlights, { id: domNode.attribs.value });

            return _react2.default.createElement(
              'strong',
              {
                style: _getStyles2.default.mention(color, myMessage, onHighlightClick),
                onClick: function onClick(e) {
                  return onHighlightClick(e, value);
                }
              },
              (0, _domToReact2.default)(domNode.children)
            );
          }

          if (domNode.attribs && domNode.attribs.class === 'link') {
            var _value = domNode.attribs.value;


            return _react2.default.createElement(
              'a',
              { style: _styles2.default.link, href: _value, target: '_blank', rel: 'noopener noreferrer' },
              (0, _domToReact2.default)(domNode.children)
            );
          }

          return domNode;
        }
      };

      return (0, _htmlReactParser2.default)(_this.createMarkup(), options);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TextMessage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          color = _props.color,
          myMessage = _props.myMessage,
          avatar = _props.avatar,
          compact = _props.compact,
          style = _props.style,
          fontSize = _props.fontSize,
          messageHeaderStyle = _props.messageHeaderStyle,
          body = _props.body,
          createdAt = _props.createdAt,
          username = _props.username,
          type = _props.type,
          messageBodyStyle = _props.messageBodyStyle,
          messageTimeStyle = _props.messageTimeStyle,
          emoji = _props.emoji,
          enableLinks = _props.enableLinks,
          edited = _props.edited,
          highlights = _props.highlights,
          badge = _props.badge,
          iconMenu = _props.iconMenu,
          enableMultiline = _props.enableMultiline;


      return _react2.default.createElement(
        'div',
        { style: _getStyles2.default.root(color, myMessage, avatar, compact, iconMenu, style) },
        _react2.default.createElement(_messageHeader2.default, {
          avatar: avatar,
          compact: compact,
          myMessage: myMessage,
          fontSize: fontSize,
          headerStyle: messageHeaderStyle,
          username: username,
          badge: badge,
          iconMenu: !(0, _isEmpty2.default)(iconMenu)
        }),
        _react2.default.createElement(
          'p',
          { className: fontSize, style: _getStyles2.default.body(myMessage, fontSize, messageBodyStyle) },
          enableLinks || enableMultiline || emoji || !(0, _isEmpty2.default)(highlights) ? _react2.default.createElement(
            'span',
            null,
            this.parseHtml()
          ) : body,
          _react2.default.createElement(_messageTime2.default, {
            myMessage: myMessage,
            type: type,
            style: messageTimeStyle,
            createdAt: createdAt,
            edited: edited,
            fontSize: fontSize
          })
        ),
        iconMenu ? _react2.default.createElement(
          'div',
          { style: _styles2.default.iconMenu },
          iconMenu
        ) : null
      );
    }
  }]);

  return TextMessage;
}(_react.Component);

TextMessage.propTypes = propTypes;
TextMessage.defaultProps = defaultProps;

exports.default = TextMessage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/message/text-message/index.js
// module id = 720
// module chunks = 0